<template>
	<transition name="modal-fade">
		<div v-if="isOpen" class="modal-overlay" @click="handleOverlayClick">
			<div class="modal-container" @click.stop>
				<!-- Header -->
				<div class="modal-header">
					<slot name="header">
						<h2 class="modal-title">{{ title }}</h2>
					</slot>
					<button class="modal-close" @click="close" aria-label="Close modal">
						&times;
					</button>
				</div>

				<!-- Body -->
				<div class="modal-body">
					<slot name="body">
						<!-- Default body content -->
					</slot>
				</div>

				<!-- Actions -->
				<div class="modal-actions">
					<slot name="actions">
						<!-- Default action buttons can go here -->
					</slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Modal Title'
		},
		closeOnOverlay: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
		handleOverlayClick() {
			if (this.closeOnOverlay) {
				this.close();
			}
		}
	}
};
</script>

<style scoped>
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.modal-container {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	max-width: 500px;
	width: 90%;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
}

.modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	border-bottom: 1px solid #e5e5e5;
}

.modal-title {
	margin: 0;
	font-size: 20px;
	font-weight: 600;
}

.modal-close {
	background: none;
	border: none;
	font-size: 28px;
	cursor: pointer;
	color: #999;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: color 0.2s;
}

.modal-close:hover {
	color: #333;
}

.modal-body {
	padding: 20px;
	overflow-y: auto;
	flex: 1;
}

.modal-actions {
	padding: 20px;
	border-top: 1px solid #e5e5e5;
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}

/* Transition animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.3s;
}

.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
	transition: transform 0.3s;
}

.modal-fade-enter .modal-container,
.modal-fade-leave-to .modal-container {
	transform: scale(0.9);
}
</style>
